import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { ICertificationDocument } from '../interfaces/certifications';

const name = 'certificationDocuments';

export const fetchCertificationDocuments = createAsyncThunk(
  `${name}/fetch`,
  async (organizationId: string, { dispatch }) => {
    try {
      const { data } = await axios.get<ICertificationDocument[]>(
        `/api/v1/accreditations/${organizationId}/accreditationCertificate/all`
      );
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  certificationDocuments: ICertificationDocument[];
};

const initialState: State = {
  certificationDocuments: [],
  isFetching: false,
  error: null
};

const certificationDocuments = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchCertificationDocuments.pending, isFetching)
      .addCase(fetchCertificationDocuments.fulfilled, (state, action) => {
        state.certificationDocuments = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchCertificationDocuments.rejected, error);
  }
});

export const { reducer: certificationDocumentsReducer } = certificationDocuments;
